export const disableScroll = () => {
    document.body.style.overflowY = "hidden";
    document.body.classList.add("scroll-locked");
    var x = window.scrollX;
    var y = window.scrollY;
    window.scrollTo(x, y);
    window.onscroll = function () {
        window.scrollTo(x, y);
    };
};

export const enableScroll = () => {
    document.body.style.overflow = "";
    document.body.classList.remove("scroll-locked");
    window.onscroll = function () {};
};

export const addPageLoader = () => {
    const loader = document.createElement("div");
    loader.classList.add("page-loader");
    document.body.appendChild(loader);
};

export const removePageLoader = () => {
    const loader = document.querySelector(".page-loader");
    if (loader) {
        loader.remove();
    }
};
export const extractValueFromFormData = (formData: FormData, key: string): string | File | null => {
    let value: string | File | null = null;

    for (const entry of formData.entries()) {
        const [entryKey, entryValue] = entry;

        if (entryKey === key) {
            value = entryValue;
            break;
        }
    }

    return value;
};

export const updateUrl = (url: string): void => {
    window.history.pushState({}, "", url);
};
